import styled from '@emotion/styled';
import { Stack } from '../core/Stack';

export const StackSpaceBetween = styled(Stack)`
  justify-content: left;
  padding: 0;
`;
